var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "el-checkbox",
        {
          attrs: {
            no: "dischargingPortDoor",
            title: _vm.$t("SeaExport.DispatchVehiclesAtDestination")
          },
          on: {
            change: function($event) {
              return _vm.onChange("dischargingPortDoor")
            }
          },
          model: {
            value: _vm.job.dischargingPortDoor,
            callback: function($$v) {
              _vm.$set(_vm.job, "dischargingPortDoor", $$v)
            },
            expression: "job.dischargingPortDoor"
          }
        },
        [
          _vm._v(
            _vm._s(_vm.$t("SeaExport.DispatchVehiclesAtDestination")) + " "
          )
        ]
      ),
      _c(
        "el-checkbox",
        {
          attrs: {
            no: "usCustomsClearance",
            title: _vm.$t("queryJob.UsCustomsClearance")
          },
          on: {
            change: function($event) {
              return _vm.onChange("usCustomsClearance")
            }
          },
          model: {
            value: _vm.job.usCustomsClearance,
            callback: function($$v) {
              _vm.$set(_vm.job, "usCustomsClearance", $$v)
            },
            expression: "job.usCustomsClearance"
          }
        },
        [_vm._v(_vm._s(_vm.$t("queryJob.UsCustomsClearance")) + " ")]
      ),
      _c(
        "el-checkbox",
        {
          attrs: {
            no: "destPortCustomsClearance",
            title: _vm.$t("SeaExport.PortOfDestinationCustomsClearance")
          },
          on: {
            change: function($event) {
              return _vm.onChange("destPortCustomsClearance")
            }
          },
          model: {
            value: _vm.job.destPortCustomsClearance,
            callback: function($$v) {
              _vm.$set(_vm.job, "destPortCustomsClearance", $$v)
            },
            expression: "job.destPortCustomsClearance"
          }
        },
        [
          _vm._v(
            _vm._s(_vm.$t("SeaExport.PortOfDestinationCustomsClearance")) + " "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }